<template>
  <div class="withdraw-record  default-wrap">
    <div class="wallet-tool-bar">
      <div class="filter" :class="{ fixed: listIsFixed }">
        <date-picker
          v-model="filter.period"
          :class="{ active: filter.period[0] && filter.period[1] }"
          placeholder="請選擇日期"
          format="YYYY.MM.DD"
          value-type="YYYY/MM/DD"
          rangeSeparator="-"
          range
        ></date-picker>
        <rent-select
          refName="withdraw"
          selectMsg="所有狀態"
          @getId="getSelectId"
          border="1px solid #d5dad8"
          bgColor="#fff"
          :setDefault="isDefault"
        >
          <ul>
            <li data-id="">所有狀態</li>
            <li data-id="SUCCESS">成功</li>
            <li data-id="WITHDRAW_FAILED">失敗</li>
            <li data-id="WITHDRAW_AUDITING">等待中</li>
          </ul>
        </rent-select>
      </div>
    </div>
    <div class="table-list withdraw">
      <div class="mask"></div>
      <div class="table-list-title">
        <span class="date">申請提領時間</span>
        <span class="bank">提領至</span>
        <span class="state">狀態</span>
        <span class="reason">失敗原因</span>
        <span class="number">提領編號</span>
        <span class="price">金額</span>
      </div>
      <div class="table-list-body">
        <!-- <div v-if="withdrawList.length != 0 && filterByContractDate.length == 0" class="filter-empty">
                    <span>0 個搜尋結果</span>
                    <button class="default-button" @click="setFilterDefault">清除篩選</button>
                </div> -->
        <div v-if="isLoading" class="filter-empty">
          <table-loading />
        </div>
        <div v-else-if="withdrawList.length == 0" class="is-empty">
          0 筆資料
        </div>
        <ul v-else>
          <li v-for="(bill, index) in withdrawList" :key="index">
            <span class="date">{{ getFormatDate(bill.createdDate) }}</span>
            <span class="bank">
              <img
                :src="
                  '../../../../../static/img/bank/' + bill.bankCode + '.png'
                "
                alt=""
              />
              {{ bill.bankName }}
            </span>
            <span class="state blue" v-if="bill.transactionStatus == 'SUCCESS'"
              >成功</span
            >
            <span
              class="state red"
              v-if="bill.transactionStatus == 'WITHDRAW_FAILED'"
              >失敗</span
            >
            <span
              class="state gray"
              v-if="bill.transactionStatus == 'WITHDRAW_AUDITING'"
              >等待中</span
            >
            <span class="reason">{{
              bill.withdrawFailReason ? bill.withdrawFailReason : "-"
            }}</span>
            <span class="number">{{ transIdEncrypt(bill.transactionId) }}</span>
            <span class="price">{{ toCurrency(bill.amount) }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import Modal from "@/components/widge/Modal.vue";
import RentSelect from "@/components/bussiness/widges/tools/RentSelect.vue";
import DatePicker from "vue2-datepicker";
import walletStoredInfo from "@/components/widge/modal/walletStoredInfo.vue";
import AlartMsg from "@/components/widge/AlartMsg.vue";
import tableLoading from '@/components/bussiness/widges/tools/tableLoading.vue';

import { mapGetters } from "vuex";
export default {
  data() {
    return {
      componentKey: 0,
      isDefault: false,
      withdrawState: 0,
      withdrawFilterState: null,
      listIsFixed: false,
      isLoading: true,
      filter: {
        page: 1,
        period: ["", ""],
        status: ""
      }
    };
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
    this.$store.dispatch("getBizWalletRecordList")
    .then(()=>{
      this.isLoading = false
    })
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
    this.$store.dispatch("setBizWithdrawFilter", {
      page: 1,
      period: ["", ""],
      status: ""
    });
  },
  watch: {
    filter: {
      handler: function(val) {
        this.$store.dispatch("setBizWithdrawFilter", val).then(() => {
          this.$store.dispatch("getBizWalletRecordList");
        });
      },
      deep: true
    }
  },
  methods: {
    handleScroll(event) {
      let scrollTop = event.target.documentElement.scrollTop;
      // console.log(scrollTop)

      if (scrollTop >= 255) {
        this.listIsFixed = true;
        document.getElementsByClassName("parent-frame")[0].style.zIndex = "8";
      } else {
        document.getElementsByClassName("biz-tool-bar-wrap")[0].style.display =
          "flex";
        document.getElementsByClassName("parent-frame")[0].style.zIndex = "8";
        this.listIsFixed = false;
      }
    },
    getSelectId: function(value) {
      this.isDefault = false;

      if (value.ref == "withdraw") {
        this.filter.status = value.id;
      }
    },
    setFilterDefault: function() {
      // this.isDefault = true
      // this.filter.period = []
      // this.withdrawFilterState = null
    },
    getFormatDate: function(date) {
      var formatDate = [];
      var date = new Date(date);
      // var date = new Date(Date.parse(date));
      //一般日期 年 月 天 時 分
      formatDate[0] = date.getFullYear();
      formatDate[1] = date.getMonth() + 1;
      formatDate[2] = date.getDate();
      formatDate[3] = (Array(2).join(0) + date.getHours(-8)).slice(-2);
      formatDate[4] = (Array(2).join(0) + date.getMinutes()).slice(-2);
      formatDate[5] = (Array(2).join(0) + date.getSeconds()).slice(-2);
      //月及天兩位數
      formatDate[6] = (Array(2).join(0) + formatDate[1]).slice(-2);
      formatDate[7] = (Array(2).join(0) + formatDate[2]).slice(-2);
      // console.log(formatDate[3] )
      //換算時區 台灣-8
      // if(formatDate[3] - 8 < 0){
      //     formatDate[3] = 24+(formatDate[3]-8);
      //     formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
      // }else{
      //     formatDate[3] = formatDate[3]-8;
      //     formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
      // }
      return (
        formatDate[0] +
        "-" +
        formatDate[6] +
        "-" +
        formatDate[7] +
        " " +
        formatDate[3] +
        ":" +
        formatDate[4]
      );
      // return formatDate[0]+'-'+formatDate[5]+'-'+formatDate[6]+' '+formatDate[3]+':'+formatDate[4];
    },
    transIdEncrypt: function(id) {
      // console.log(id)
      return id.substr(0, 5) + "...";
    }
  },
  computed: {
    ...mapGetters({
      withdrawList: "GET_BIZ_WALLET_RECORD_LIST"
    })
  },
  components: {
    RentSelect,
    DatePicker,
    walletStoredInfo,
    Modal,
    AlartMsg,
    tableLoading
  }
};
</script>
<style lang="scss">
.withdraw-record {
  padding: 0;
  margin-bottom: 200px;
  .wallet-tool-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 25px 24px;
    .filter.fixed {
      display: none;
      position: fixed;
      z-index: 50;
      margin-left: 785px;
      background: #fff;
      top: 0px;
      height: 80px;
      align-items: center;
    }
    .filter {
      display: flex;
      .biz-rent-select {
        width: 216px;
      }
      .mx-datepicker {
        width: 216px;
        margin-right: 10px;
        input {
          width: 100%;
          height: 44px;
          border-radius: 4px;
          border: solid 1px #e0dfde;
          color: #a8a5a4;
          padding: 13px 16px;
          box-shadow: none;
          margin-bottom: 0px;
        }
        .mx-icon-calendar,
        .mx-icon-clear {
          right: 14px;
        }
      }
      .mx-datepicker:hover,
      .mx-datepicker.active {
        input {
          border: 1px solid #676362 !important;
          color: #676362 !important;
        }
        i {
          color: #676362;
        }
      }
    }
  }
  .withdraw {
    position: relative;
    width: 100%;
    border-radius: 0px;
    border: 0px;
    border-bottom: 1px solid #f0f0f0;
    border-top: 1px solid #f0f0f0;
    .table-list-body ul li .bank {
      display: flex;
      align-items: center;
      > img {
        width: 30px;
        height: 30px;
        margin-right: 10px;
      }
    }
    .table-list-body ul li .state {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 38px;
      border-radius: 4px;
    }
    .table-list-body ul li .state.blue {
      background-color: #f0f6fc;
      color: #71aae5;
    }
    .table-list-body ul li .state.red {
      background-color: rgba(240, 90, 62, 0.1);
      color: #fc7171;
    }
    .table-list-body ul li .state.gray {
      background-color: #f6f6f6;
      color: #a8a5a4;
    }
    .table-list-title .date,
    .table-list-body ul li .date {
      width: 112px;
      margin-right: 90px;
    }
    .table-list-title .bank,
    .table-list-body ul li .bank {
      position: relative;
      width: 210px;
      margin-right: 18px;
    }
    .table-list-title .price,
    .table-list-body ul li .price {
      width: 74px;
      text-align: right;
      color: #fc7171;
    }
    .table-list-title .state,
    .table-list-body ul li .state {
      width: 76px;
      margin-right: 90px;
    }
    .table-list-title .reason,
    .table-list-body ul li .reason {
      width: 158px;
      margin-right: 90px;
    }
    .table-list-title .number,
    .table-list-body ul li .number {
      width: 56px;
      margin-right: 90px;
    }
  }
}
// @media screen and (max-width: 1280px) {
//   .withdraw-record {
//     .wallet-tool-bar {
//       .filter.fixed {
//         margin-left: 771px;
//       }
//     }
//   }
// }
</style>



// WEBPACK FOOTER //
// src/components/bussiness/settingCenter/wallet/withdrawRecord/withdrawRecordComp.vue